<template>
  <div
    v-if="multipleFormat"
    class="modal right fade"
    id="multiEditComponentModal"
    tabindex="-1"
    aria-labelledby="multiEditComponentModalLabel"
    data-bs-keyboard="false"
    data-bs-backdrop="static"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click.prevent="handleDialogClose"
          >
            <span aria-hidden="true"><i class="fa fa-times" aria-hidden="true"></i></span>
          </button>
          <span class="headerText" id="multiEditComponentModalLabel">{{ title }}</span>
        </div>
        <div class="modal-body">
          <div class="content">
            <div class="operation">
              <div v-if="loading" style="position: relative; z-index: 999999; top: 22rem">
                <GridLoading></GridLoading>
              </div>
              <AlertComponent
                v-if="isCancelButtonClicked"
                @setWindow="showGrid"
                :isCancelButtonClicked="isCancelButtonClicked"
                @hidePopup="hidePopup"
              ></AlertComponent>
              <button class="btn btn-primary" style="width: 7rem; border-radius: 5px" @click="onSave">
                {{ $t("editComponent.save") }}
              </button>
              <div class="footer">
                <div class="child">
                  <table class="needlesTable">
                    <thead>
                      <tr>
                        <th>{{ $t("multiEditComponent.stitchCode") }}</th>
                        <th>{{ $t("operationCreateComp.component") }}</th>
                        <th>
                          {{
                            seamLengthUnit == 0
                              ? $t("operationCreateComp.consumption") + " 10 cm"
                              : $t("operationCreateComp.consumption") + " 3.94 inch"
                          }}
                        </th>
                        <th>{{ $t("editComponent.brand") }}</th>
                        <th>{{ ticketTex == "Tkt" ? $t("editComponent.tkt") : $t("editComponent.tex") }}</th>
                        <th>{{ $t("editComponent.shade") }}</th>
                        <th>{{ $t("editComponent.packageSize") }}</th>
                      </tr>
                    </thead>
                    <tbody v-for="(items, id1) in componentsData" :key="id1">
                      <tr v-for="(item, id) in items.components" :key="id">
                        <td v-if="id === 0" class="stitchCode">
                          {{ items.stitchTypeCode }}
                        </td>
                        <td v-else></td>
                        <td style="text-align: left">{{ item.needleName }}</td>
                        <td>{{ consumptionValues[id1]?.[id] }}</td>
                        <td>
                          <ComboBox
                            :data-source="brands.length ? brands : []"
                            :data-text-field="'text'"
                            :data-value-field="'value'"
                            :height="130"
                            :filter="'contains'"
                            :key="'id'"
                            v-model="componentsData[id1].components[id].brandId"
                            :value="componentsData[id1].components[id].brandId"
                            @change="handleBrandChange($event.sender._cascadedValue, id, id1)"
                            style="font-size: 12px !important; width: 11.5em; box-sizing: border-box"
                          >
                          </ComboBox>
                        </td>
                        <td>
                          <ComboBox
                            :data-source="tktTexs.length ? tktTexs : []"
                            :data-text-field="'text'"
                            :data-value-field="'value'"
                            :height="130"
                            :filter="'contains'"
                            :key="'id'"
                            v-model="componentsData[id1].components[id].ticketTex"
                            @change="handleTktTexChange($event.sender._cascadedValue, id, id1)"
                            @open="getTktTexData(componentsData[id1].components[id].brandId, id, id1)"
                            :value="componentsData[id1].components[id].ticketTex"
                            style="width: 7em; font-size: 12px !important"
                          >
                          </ComboBox>
                        </td>
                        <td>
                          <ComboBox
                            :data-source="shades.length ? shades : []"
                            :data-text-field="'text'"
                            :data-value-field="'value'"
                            :height="130"
                            :filter="'contains'"
                            :key="'id'"
                            v-model="componentsData[id1].components[id].shade"
                            :value="componentsData[id1].components[id].shade"
                            style="width: 9.1em; font-size: 12px !important"
                          >
                          </ComboBox>
                        </td>
                        <td>
                          <ComboBox
                            :data-source="packageSizes.length ? packageSizes : []"
                            :data-text-field="'text'"
                            :data-value-field="'value'"
                            :height="130"
                            :filter="'contains'"
                            :key="'id'"
                            v-model="componentsData[id1].components[id].packageSize"
                            @open="getPackageSizeData(componentsData[id1].components[id].ticketTex, id, id1)"
                            :value="componentsData[id1].components[id].packageSize"
                            style="width: 7em; font-size: 12px !important"
                          >
                          </ComboBox>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="7" style="height: 20px; background: transparent"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <p v-if="!isV4CalculationEngine" class="wastageNote">
                  {{ $t("styleGrid.threadWastageNote") }}
                </p>

                <div class="buttons">
                  <button class="btn btn-primary" style="width: 7rem; border-radius: 5px" @click="onSave">
                    {{ $t("editComponent.save") }}
                  </button>
                  <button
                    class="btn btn-secondary"
                    style="width: 8rem; border-radius: 5px"
                    @click="isCancelButtonClicked = true"
                  >
                    {{ $t("editComponent.cancel") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Dialog } from "@progress/kendo-vue-dialogs";
import { ComboBox } from "@progress/kendo-dropdowns-vue-wrapper";
import {
  StyleOperationStitchNBLCApi,
  BrandApi,
  TicketTexApi,
  ShadeApi,
  PackageSizeApi,
  StitchNBLCTypesApi
} from "@/api";
import AlertComponent from "./AlertComponent.vue";
import GridLoading from "./GridLoading.vue";
import { defineComponent } from "vue";
import { useToast } from "vue-toastification";

export default defineComponent({
  name: "MultiEditComponent",
  components: {
    "k-dialog": Dialog,
    ComboBox,
    AlertComponent,
    GridLoading
  },
  props: {
    selectedRowIds: null as any,
    multipleFormat: null as any,
    selectedOperationCount: null as any,
    seamLengthUnit: null as any,
    consumptionData: null as any,
    ticketTex: null as any,
    calculationEngineType: {
      type: String,
      default: ""
    },
    isMultiEditClicked: {
      type: Boolean,
      default: false
    }
  },
  emits: ["showGrid"],
  computed: {
    isV4CalculationEngine(): boolean {
      const engineType = String(this.calculationEngineType ?? "")
        .trim()
        .toLowerCase();
      return engineType === "gsdv4";
    }
  },
  setup() {
    const styleOperationStitchNBLCApi = new StyleOperationStitchNBLCApi()!;
    const brandApi = new BrandApi()!;
    const ticketTexApi = new TicketTexApi()!;
    const shadeApi = new ShadeApi()!;
    const packageSizeApi = new PackageSizeApi()!;
    const stitchNBLCTypesApi = new StitchNBLCTypesApi()!;
    return {
      styleOperationStitchNBLCApi,
      brandApi,
      ticketTexApi,
      shadeApi,
      packageSizeApi,
      stitchNBLCTypesApi
    };
  },
  mounted() {
    if (this.multipleFormat) {
      this.$nextTick(() => {
        ($("#multiEditComponentModal") as any).modal("show");
        const modalElement = document.getElementById("multiEditComponentModal");
        if (modalElement) {
          const onShown = () => {
            (modalElement as any).removeEventListener("shown.bs.modal", onShown);
          };

          (modalElement as any).addEventListener("shown.bs.modal", onShown);
        }
      });
    }
    ($("#multiEditComponentModal") as any).modal({
      backdrop: false,
      keyboard: false,
      focus: false
    });
  },
  data() {
    return {
      multipleformat: this.multipleFormat,
      title: "Update Operation",
      componentsData: [] as any,
      hideDialog: null as any,
      loading: false,
      brands: [] as any,
      tktTexs: [] as any,
      shades: [] as any,
      packageSizes: [] as any,
      isCancelButtonClicked: false,
      operationsSelected: this.$t("multiEditComponent.operationsSelected"),
      error: this.$t("multiEditComponent.error"),
      success: this.$t("multiEditComponent.success"),
      threadInformationUpdatedSuccessfully: this.$t("multiEditComponent.threadInformationUpdatedSuccessfully"),
      errorInEditingData: this.$t("multiEditComponent.errorInEditingData"),
      consumptionValues: [] as any,
      toast: useToast(),
      isStitchTypeValidation: [] as any,
      selectValueFromList: (this.$t("operationCreateComp.error") +
        ": " +
        this.$t("itemSelectModal.pleaseSelect") +
        " " +
        this.$t("itemSelectModal.fromTheList")) as string
    };
  },
  watch: {
    isMultiEditClicked(newVal) {
      if (newVal && this.selectedRowIds) {
        this.loadData();
      }
    }
  },
  created(): void {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      this.getMultipleOperationData();
      this.getBrandData();
      this.getShadeData();
      this.title += " " + "( " + this.selectedOperationCount + " " + this.operationsSelected + " )";
      this.loading = false;
    },
    handleBrandChange(selectedBrandId: any, id: any, id1: any) {
      const isValid = this.brands.some((item: any) => item.value == selectedBrandId);
      if (
        selectedBrandId === null ||
        selectedBrandId === undefined ||
        String(selectedBrandId).trim() === "" ||
        isValid
      ) {
        this.isStitchTypeValidation[id] = true;
        this.getTktTexData(selectedBrandId, id, id1);
      } else {
        this.isStitchTypeValidation[id] = false;
        this.toast.error(this.selectValueFromList, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    },
    handleTktTexChange(selectedId: any, id: any, id1: any) {
      const isValid = this.tktTexs.some((item: any) => item.value == selectedId);
      if (selectedId === null || selectedId === undefined || String(selectedId).trim() === "") {
        this.isStitchTypeValidation[id] = true;
      } else if (isValid) {
        this.isStitchTypeValidation[id] = true;
        this.getPackageSizeData(selectedId, id, id1);
      } else {
        this.isStitchTypeValidation[id] = false;
        this.toast.error(this.selectValueFromList, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    },
    handleDialogClose() {
      this.isCancelButtonClicked = true;
    },
    hidePopup(value: boolean): void {
      this.isCancelButtonClicked = value;
    },
    showGrid(value: boolean): void {
      this.multipleformat = value;
      this.$emit("showGrid", this.multipleformat);
    },
    async getMultipleOperationData(): Promise<void> {
      await this.styleOperationStitchNBLCApi
        .apiGetStyleOperationNblcsGet(this.selectedRowIds, this.ticketTex as string)
        .then(res => {
          this.componentsData = res.data;
        });
      this.setConsumptionData();
    },
    setConsumptionData(): void {
      this.consumptionValues = [];
      for (let [index, item] of this.componentsData.entries()) {
        this.consumptionValues[index] = [
          this.consumptionData[item.stitchTypeCode].headType1Consumption,
          this.consumptionData[item.stitchTypeCode].headType2Consumption,
          this.consumptionData[item.stitchTypeCode].headType3Consumption,
          this.consumptionData[item.stitchTypeCode].headType4Consumption
        ];
      }
    },
    async getBrandData(): Promise<void> {
      this.brands = [];
      await this.brandApi.apiGeBrandsOrderByMostFrequentlyUsedGet().then(async (res: { data: any[] }) => {
        for (let brand of res.data) {
          let data = {
            text: brand.name,
            value: brand.id
          };
          this.brands.push(data);
        }
      });
    },
    async getTktTexData(brandId: number, id: number, id1: number): Promise<void> {
      this.componentsData[id1].components[id].brandId = brandId;
      this.tktTexs = [];
      this.componentsData[id1].components[id].ticketTex = null;
      this.componentsData[id1].components[id].packageSize = null;
      if (brandId != null && brandId > 0) {
        await this.ticketTexApi.apiGetTickeTexsByBrandIdGet(brandId).then(async res => {
          for (let value of res.data) {
            let ticketOrTex = this.ticketTex == "Tkt" ? value.ticket : value.tex;
            let data = {
              text: ticketOrTex,
              value: ticketOrTex
            };
            this.tktTexs.push(data);
          }
        });
      }
    },
    async getShadeData(): Promise<void> {
      this.shades = [];
      await this.shadeApi.apiShadeGetShadesOrderByMostFrequentlyUsedGet().then(async res => {
        for (let shade of res.data) {
          let data = {
            text: shade.name,
            value: shade.name
          };
          this.shades.push(data);
        }
      });
    },
    async getTktTexIdByValue(brandId: number, tktTexVal: string, tktTex: string): Promise<number> {
      let tktTexId = 0;
      await this.ticketTexApi.apiGetTickeTexsByBrandIdGet(brandId).then(async res => {
        tktTexId =
          tktTexVal == "Tkt"
            ? (res.data.find(a => a.ticket == tktTex)?.id as number)
            : (res.data.find(a => a.tex == tktTex)?.id as number);
      });
      return tktTexId;
    },
    async getPackageSizeData(tktTex: string, id: number, id1: number): Promise<void> {
      this.componentsData[id1].components[id].ticketTex = tktTex;
      this.packageSizes = [];
      this.componentsData[id1].components[id].packageSize = null;
      if (tktTex != null) {
        let tktTexId = await this.getTktTexIdByValue(
          this.componentsData[id1].components[id].brandId as number,
          this.ticketTex as string,
          tktTex
        );
        await this.packageSizeApi.apiGetPacakageSizesByTicketTexIDGet(tktTexId).then(async res => {
          for (let value of res.data) {
            let data = {
              value: value.size,
              text: value.size
            };
            this.packageSizes.push(data);
          }
        });
      }
    },
    async trimShade() {
      for (let component of this.componentsData) {
        for (let operation of component.components) {
          if (operation.shade != null) {
            operation.shade = operation.shade.trim();
          }
        }
      }
    },
    async onSave(): Promise<void> {
      this.loading = true;
      if (this.isStitchTypeValidation.every(Boolean)) {
        for (let [index, item] of this.componentsData.entries()) {
          for (let [id, value] of item.components.entries()) {
            if (value.brandId == "") {
              this.componentsData[index].components[id].brandId = null;
            }
            if (value.packageSize == "") {
              this.componentsData[index].components[id].packageSize = null;
            }
          }
        }
        await this.trimShade();
        await this.styleOperationStitchNBLCApi
          .apiUpdateOperationNblcsPost(this.ticketTex as string, this.componentsData)
          .then(res => {
            if (res.data) {
              this.toast.success(this.threadInformationUpdatedSuccessfully as string, {
                toastClassName: "custom-success-toast",
                timeout: 5000
              });
            }
          })
          .catch(() => {
            this.toast.error(this.errorInEditingData as string, {
              toastClassName: "custom-error-toast",
              timeout: 5000
            });
          });
        this.$emit("showGrid", this.multipleFormat);
        this.loading = false;
      } else {
        this.loading = false;
        this.toast.error(this.errorInEditingData as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    }
  }
});
</script>

<style scoped>
.stitchCode {
  padding: 7px;
  font-weight: 600;
  color: #1d1d1ebf;
  width: 100px;
  margin-left: 26px;
}
.components {
  position: relative;
  display: flex;
  padding-top: 5px;
  font-size: 14px;
  left: 6.5rem;
  top: -1.9rem;
  width: 100%;
  gap: 12px;
}
.parent {
  background-color: #d9d9de;
  width: 100%;
  gap: 12px;
  margin-top: 25px;
  color: #575759;
  font-size: 15px;
  font-weight: 700;
}
.heading {
  margin: 7px;
  font-size: 13px;
}
.buttons {
  display: flex;
  margin: 13px;
  margin-top: 45px;
  gap: 12px;
}
.wastageNote {
  margin: 12px 0 0 3px;
  font-size: 12px;
  color: #6c757d;
}
.k-window-titlebar {
  color: #000000 !important;
  background-color: #ffffff !important;
}
.b-toaster {
  z-index: 999999 !important;
}
.k-input {
  font-size: 12px !important;
  padding: 0px 0px !important;
}
.body {
  display: grid;
  margin-top: 15px;
}
.btn-primary {
  background-color: #0054a6;
  color: white;
}
.modal-header {
  position: sticky;
  background-color: #0054a6;
  color: white;
  padding: 0.75rem;
  height: auto;
}

.modal.right .modal-dialog {
  position: fixed;
  margin: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 55vw;
  max-width: 100%;
  font-family: Arial, Helvetica, sans-serif;
  color: white;
}
.modal.right .modal-content {
  height: 100%;
  overflow-y: auto;
  border-radius: 0 !important;
}

body.modal-open {
  overflow-x: hidden;
  border-radius: 0 !important;
}
.modal-header i.fa-times {
  color: white !important;
}
.headerText {
  font-size: 16px;
  width: 100%;
}
.modal.fade {
  transition: none !important;
}

.modal.fade.show {
  opacity: 1 !important;
}
.modal {
  pointer-events: none !important;
}
.needlesTable {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  margin-left: -10px;
}
.needlesTable th,
.needlesTable td {
  border: none;
  text-align: center;
  vertical-align: middle;
  padding: 3px;
}
.needlesTable th {
  background: #d9d9de;
  color: #575759;
  font-size: 14px;
  font-weight: 700;
}
</style>
